import { AsyncStatus, defaultInitialState, State } from 'hooks/useAsync';
import { useCallback, useState } from 'react';
import SalesforceService, {
  SalesforceVerifyIntegrationResult,
} from './SalesforceService';

const useVerifySalesforceIntegration = () => {
  const [{ error, isLoading, data, status }, setState] =
    useState<State<SalesforceVerifyIntegrationResult>>(defaultInitialState);

  const verifySalesforceIntegration = useCallback(async () => {
    setState({
      error: null,
      status: AsyncStatus.pending,
      data: null,
      isLoading: true,
    });
    const resultPromise = SalesforceService.verifySalesforceIntegration();
    resultPromise.then(
      (result) => {
        setState({
          error: null,
          status: AsyncStatus.resolved,
          data: result,
          isLoading: false,
        });
      },
      (error) => {
        setState({
          error: error,
          status: AsyncStatus.rejected,
          data: null,
          isLoading: false,
        });
      },
    );
  }, [setState]);

  return {
    verifySalesforceIntegration,
    error,
    isLoading,
    isError:
      status === AsyncStatus.rejected ||
      (data?.data ? !data?.data.isSuccess : false),
    isSuccess: status === AsyncStatus.resolved && data?.data.isSuccess,
    data,
  };
};

export default useVerifySalesforceIntegration;
